export default "__VITE_ASSET__DOOvsIHX__"